/* eslint-disable eag/match-named-export */

export const MAKE_OTHER = 'MAKE_OTHER';
export const MODEL_FAMILY_OTHER_END = '-MODELFAMILY_OTHER';
export const MODEL_FAMILY_OTHER = `MAKE_OTHER${MODEL_FAMILY_OTHER_END}`;
